import React from 'react';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: readonly RadioOption[] | RadioOption[];
  name: string;
  error?: boolean;
  className?: string;
}

export function RadioGroup({
  value,
  onChange,
  options,
  name,
  error = false,
  className = '',
}: RadioGroupProps) {
  return (
    <div className={`grid grid-cols-2 gap-4 ${className}`}>
      {options.map((option) => (
        <label
          key={option.value}
          className={`flex items-center p-3 rounded-lg border-2 cursor-pointer transition duration-150 bg-white hover:bg-slate-50 ${
            value === option.value
              ? 'border-[#CEAB65] bg-[#CEAB65]/5'
              : error
                ? 'border-red-500'
                : 'border-slate-300'
          }`}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            className="h-4 w-4 text-[#CEAB65] border-slate-300 focus:ring-[#CEAB65]"
          />
          <span className="ml-3 text-[#1D314D] font-medium">{option.label}</span>
        </label>
      ))}
    </div>
  );
}
